import { authenticatedRoutes } from "../routes/constant";
import {
    AddBooking,
    AddBookingTable,
    AddBusiness,
    AddEvent,
    AddService,
    BookingDetails,
    BookingManagement,
    BusinessDetail,
    BusinessManagement,
    Dashboard,
    EditBooking,
    EditBookingTable,
    EditBusiness,
    EditEvent,
    EditProfile,
    EditService,
    EventDetails,
    EventManagement,
    ServiceDetails,
    ServiceManagement,
    ServiceOrderListing,
    BookingOrderListing,
    SettingScreen,
    TicketManagement,
    UserManagement,
    UserProfile,
    UserPurchased,
    MyEarning,
    StripeOauth,
    TermsConditions,
    ArtistDetails,
    AddEditArtist,
    VerifyTicket,
    EventDetailsQrTickets,
    EventDetailCreatePurchase,
    EventDetailCreatePurchaseOTP,
    PayoutManagement,
    CurrencyManagement,
    AddCurrency,
    ViewTransactions,
    TicketDetails,
} from "../routes/lazy-imports";

export const ROLE_DEFAULT_ROUTE = {
    Admin: "/dashboard",
};

export const ROLE_BASE_SIDE_BAR_OPTIONS = {
    ADMIN: [
        {
            text: "Dashboard",
            linkTo: "/dashboard",
            selectedOptionKey: "dashboard",
            icon: "kl-icon-dashboard",
        },
        {
            text: "User Management",
            linkTo: "/user-management",
            selectedOptionKey: "user-management",
            icon: "kl-icon-user-management",
        },
        {
            text: "Event Management",
            linkTo: "/event-management",
            selectedOptionKey: "event-management",
            icon: "kl-icon-event-management",
        },
        {
            text: "Service Management",
            linkTo: "/service-management",
            selectedOptionKey: "service-management",
            icon: "kl-icon-service-management",
        },
        {
            text: "Booking Management",
            linkTo: "/booking-management",
            selectedOptionKey: "booking-management",
            icon: "kl-icon-booking-management",
        },
        {
            text: "Ticket Management",
            linkTo: "/ticket-management",
            selectedOptionKey: "ticket-management",
            icon: "kl-icon-ticket-management",
        },
        {
            text: "Business Management",
            linkTo: "/business-management",
            selectedOptionKey: "business-management",
            icon: "kl-business-management",
        },
        {
            text: "Currency Management",
            linkTo: "/currency-management",
            selectedOptionKey: "currency-management",
            icon: "kl-icon-settings",
        },
        {
            text: "Settings",
            linkTo: "/setting",
            selectedOptionKey: "setting",
            icon: "kl-icon-settings",
        },
        {
            text: "Payouts",
            linkTo: "/payout",
            selectedOptionKey: "payout",
            icon: "kl-icon-my-earning",
        },
    ],
    VENDOR: [
        {
            text: "Dashboard",
            linkTo: "/dashboard",
            selectedOptionKey: "dashboard",
            icon: "kl-icon-dashboard",
        },
        {
            text: "Event Management",
            linkTo: "/event-management",
            selectedOptionKey: "event-management",
            icon: "kl-icon-event-management",
        },
        {
            text: "Service Management",
            linkTo: "/service-management",
            selectedOptionKey: "service-management",
            icon: "kl-icon-service-management",
        },
        {
            text: "Booking Management",
            linkTo: "/booking-management",
            selectedOptionKey: "booking-management",
            icon: "kl-icon-booking-management",
        },
        {
            text: "Purchased Tickets",
            linkTo: "/ticket-management",
            selectedOptionKey: "ticket-management",
            icon: "kl-icon-ticket-management",
        },
        {
            text: "My Earnings",
            linkTo: "/my-earning",
            selectedOptionKey: "my-earning",
            icon: "kl-icon-my-earning",
        },
        {
            text: "Payouts",
            linkTo: "/payout",
            selectedOptionKey: "payout",
            icon: "kl-icon-my-earning",
        },

        {
            text: "Settings",
            linkTo: "/setting",
            selectedOptionKey: "setting",
            icon: "kl-icon-settings",
        },
    ],
};

export const AUTHENTICATED_ROUTE_OPTIONS = {
    Admin: [
        {
            linkTo: authenticatedRoutes.DASHBOARD,
            component: Dashboard,
        },

        {
            linkTo: authenticatedRoutes.SETTING,
            component: SettingScreen,
        },

        {
            linkTo: authenticatedRoutes.USERMANAGEMENT,
            component: UserManagement,
        },

        {
            linkTo: authenticatedRoutes.EVENTMANAGEMENT,
            component: EventManagement,
        },

        {
            linkTo: authenticatedRoutes.SERVICEMANAGEMENT,
            component: ServiceManagement,
        },
        {
            linkTo: authenticatedRoutes.USER_PURCHASED,
            component: UserPurchased,
        },

        {
            linkTo: authenticatedRoutes.EVENT_DETAILS,
            component: EventDetails,
        },
        {
            linkTo: authenticatedRoutes.EVENT_DETAILS_QR_TICKET_MAPPER,
            component: EventDetailsQrTickets,
        },
        {
            linkTo: authenticatedRoutes.EVENT_DETAILS_CREATE_PURCHASE,
            component: EventDetailCreatePurchase,
        },
        {
            linkTo: authenticatedRoutes.EVENT_DETAILS_CREATE_PURCHASE_OTP,
            component: EventDetailCreatePurchaseOTP,
        },
        {
            linkTo: authenticatedRoutes.EVENT_DETAILS,
            component: EventDetails,
        },

        {
            linkTo: authenticatedRoutes.USER_PROFILE,
            component: UserProfile,
        },

        {
            linkTo: authenticatedRoutes.SERVICE_DETAILS,
            component: ServiceDetails,
        },

        {
            linkTo: authenticatedRoutes.ADD_SERVICE,
            component: AddService,
        },

        {
            linkTo: authenticatedRoutes.EDIT_SERVICE,
            component: EditService,
        },

        {
            linkTo: authenticatedRoutes.TICKET_MANAGEMENT,
            component: TicketManagement,
        },

        {
            linkTo: authenticatedRoutes.BOOKINGMANAGEMENT,
            component: BookingManagement,
        },

        {
            linkTo: authenticatedRoutes.BOOKING_DETAILS,
            component: BookingDetails,
        },

        {
            linkTo: authenticatedRoutes.ADD_EVENT,
            component: AddEvent,
        },
        {
            linkTo: authenticatedRoutes.EDIT_EVENT,
            component: EditEvent,
        },

        {
            linkTo: authenticatedRoutes.ADD_BOOKING,
            component: AddBooking,
        },

        {
            linkTo: authenticatedRoutes.EDIT_BOOKING,
            component: EditBooking,
        },

        {
            linkTo: authenticatedRoutes.EDIT_PROFILE,
            component: EditProfile,
        },

        {
            linkTo: authenticatedRoutes.BUSINESS_MANAGEMENT,
            component: BusinessManagement,
        },

        {
            linkTo: authenticatedRoutes.ADD_BUSINESS,
            component: AddBusiness,
        },

        {
            linkTo: authenticatedRoutes.ADD_BOOKING_TABLE,
            component: AddBookingTable,
        },

        {
            linkTo: authenticatedRoutes.EDIT_BOOKING_TABLE,
            component: EditBookingTable,
        },

        {
            linkTo: authenticatedRoutes.BUSINESS_MANAGEMENT_UPDATE,
            component: EditBusiness,
        },

        {
            linkTo: authenticatedRoutes.BUSINESS_MANAGEMENT_DETAIL,
            component: BusinessDetail,
        },
        {
            linkTo: authenticatedRoutes.TICKET_MANAGEMENT_DETAIL,
            component: TicketDetails,
        },
        {
            linkTo: authenticatedRoutes.TERMS_CONDITIONS,
            component: TermsConditions,
        },
        {
            linkTo: authenticatedRoutes.ARTIST_DETAILS,
            component: ArtistDetails,
        },
        {
            linkTo: authenticatedRoutes.ADD_EDIT_ARTIST,
            component: AddEditArtist,
        },
        {
            linkTo: authenticatedRoutes.VERIFY_TICKET,
            component: VerifyTicket,
        },
        {
            linkTo: authenticatedRoutes.PAYOUT,
            component: PayoutManagement,
        },
        {
            linkTo: authenticatedRoutes.CURRENCY_MANAGEMENT,
            component: CurrencyManagement,
        },
        {
            linkTo: authenticatedRoutes.ADD_CURRENCY,
            component: AddCurrency,
        },
        {
            linkTo: authenticatedRoutes.VIEW_TRANSACTION,
            component: ViewTransactions,
        },
    ],
    Vendor: [
        {
            linkTo: authenticatedRoutes.DASHBOARD,
            component: Dashboard,
        },

        {
            linkTo: authenticatedRoutes.SETTING,
            component: SettingScreen,
        },
        {
            linkTo: authenticatedRoutes.STRIPE_OAUTH,
            component: StripeOauth,
        },
        {
            linkTo: authenticatedRoutes.EVENTMANAGEMENT,
            component: EventManagement,
        },

        {
            linkTo: authenticatedRoutes.SERVICEMANAGEMENT,
            component: ServiceManagement,
        },

        {
            linkTo: authenticatedRoutes.EVENT_DETAILS,
            component: EventDetails,
        },
        {
            linkTo: authenticatedRoutes.EVENT_DETAILS_QR_TICKET_MAPPER,
            component: EventDetailsQrTickets,
        },
        {
            linkTo: authenticatedRoutes.EVENT_DETAILS_CREATE_PURCHASE,
            component: EventDetailCreatePurchase,
        },
        {
            linkTo: authenticatedRoutes.EVENT_DETAILS_CREATE_PURCHASE_OTP,
            component: EventDetailCreatePurchaseOTP,
        },
        {
            linkTo: authenticatedRoutes.USER_PROFILE,
            component: UserProfile,
        },
        {
            linkTo: authenticatedRoutes.VENDOR_SERVICE_DETAILS,
            component: ServiceDetails,
        },

        {
            linkTo: authenticatedRoutes.ADD_SERVICE,
            component: AddService,
        },

        {
            linkTo: authenticatedRoutes.VENDOR_EDIT_SERVICE,
            component: EditService,
        },

        {
            linkTo: authenticatedRoutes.TICKET_MANAGEMENT,
            component: TicketManagement,
        },

        {
            linkTo: authenticatedRoutes.BOOKINGMANAGEMENT,
            component: BookingManagement,
        },
        {
            linkTo: authenticatedRoutes.VENDOR_BOOKING_DETAILS,
            component: BookingDetails,
        },
        {
            linkTo: authenticatedRoutes.ADD_EVENT,
            component: AddEvent,
        },
        {
            linkTo: authenticatedRoutes.EDIT_EVENT,
            component: EditEvent,
        },
        {
            linkTo: authenticatedRoutes.ADD_BOOKING,
            component: AddBooking,
        },
        {
            linkTo: authenticatedRoutes.VENDOR_EDIT_BOOKING,
            component: EditBooking,
        },
        {
            linkTo: authenticatedRoutes.EDIT_PROFILE,
            component: EditProfile,
        },
        {
            linkTo: authenticatedRoutes.ADD_BOOKING_TABLE,
            component: AddBookingTable,
        },
        {
            linkTo: authenticatedRoutes.EDIT_BOOKING_TABLE,
            component: EditBookingTable,
        },
        {
            linkTo: authenticatedRoutes.SERVICE_ORDER_LISTING,
            component: ServiceOrderListing,
        },
        {
            linkTo: authenticatedRoutes.BOOKING_ORDER_LISTING,
            component: BookingOrderListing,
        },
        {
            linkTo: authenticatedRoutes.ARTIST_DETAILS,
            component: ArtistDetails,
        },
        {
            linkTo: authenticatedRoutes.ADD_EDIT_ARTIST,
            component: AddEditArtist,
        },
        {
            linkTo: authenticatedRoutes.MY_EARNING,
            component: MyEarning,
        },
        {
            linkTo: authenticatedRoutes.TERMS_CONDITIONS,
            component: TermsConditions,
        },
        {
            linkTo: authenticatedRoutes.PAYOUT,
            component: PayoutManagement,
        },
        {
            linkTo: authenticatedRoutes.VERIFY_TICKET,
            component: VerifyTicket,
        },
    ],
};
